export default {
  "pagina-inicial": "Página inicial",
  "painel": "Painel",
  "editar-operacao": "Editar operação",
  entrar: "Entrar",
  senha: "Senha",
  informe: "Informe",
  nome: "Nome",
  "data-cadastro": "Data do cadastro",
  "cadastro": "Cadastro",
  "atualizar-cadastro" : "Atualizar",
  "editar-cadastro": "Editar Cadastro de Usuário",
  "alterar-senha": "Alterar senha do Usuário",
  "cadastre-se": "Cadastre-se",
  "cadastrar": "Cadastrar",
  "cadastro-validado" : "Cadastro Validado",
  "cadastro-beta-ativo" : "Cadastro Beta Ativo",
  "cadastro-ativo" : "Cadastro Ativo",
  "administrador": "Administrador",
  "user-tempo": "Período de Acesso",
  "usuario-nao-beta" : "O usuário não é BetaUser, cadastre!",
  "user-tempo-inicio": "Início do Período",
  "user-tempo-final": "Término do Período",
  "cadastro-sucesso":
    "Cadastro efetuado com sucesso. Verifique seu e-mail para a confirmação de cadastro.",
  "redefinir-senha": "Redefinir Senha",
  "senhas-diferentes": "Erro de confirmação de senha",
  "confirma-senha": "Confirmação de senha",
  "verifique-seu-email": "Verifique seu email",
  "senha-redefinida-sucesso": "Senha redefinida com sucesso",
  enviar: "Enviar",
  voltar: "Voltar",
  "email-invalido": "O e-mail inserido é inválido",
  "cpf-invalido": "O CPF inserido é inválido",
  "erro-api": "Ocorreu um erro. Por favor, tente novamente.",
  "erro-estimativa-valor":
    "Erro ao estimar o valor da consulta. Por favor, tente novamente.",
  "selecionar-todos": "Selecionar Todos",
  "expandir-todos": "Expandir Todos",
  "ocultar-todos": "Ocultar Todos",
  "valor-base": "Valor Base",
  "subtotal-area": "Subtotal Área",
  "atividades-economicas":
    "Atividades econômicas",
  "ajuda-analise-atividades-economicas":
    "MCR 2-9-3: Não será concedido crédito rural para empreendimento situado em imóvel rural total ou parcialmente inserido em Unidade de Conservação, desde que registrado no Cadastro Nacional de Unidades de Conservação (CNUC) do Ministério do Meio Ambiente e Mudança do Clima (MMA), salvo se a atividade econômica se encontrar em conformidade com o Plano de Manejo da Unidade de Conservação",
  "Uso-Especifico": "{num, plural, one {Uso específico} other {Usos específicos}}",
  "subtotal-documentos": "Subtotal Documentos",
  desconto: "Desconto",
  total: "Total",
  "executar-analise-erro":
    "Erro ao criar consulta. Por favor, tente novamente.",
  "executar-analise-sucesso": "Consulta criada com sucesso!",
  "detalhes-consulta": "Detalhes da consulta:",
  municipio: "Município",
  area: "Área",
  "area-ha": "Área (ha)",
  "area-consultada": "Área Consultada",
  legenda: "Legenda",
  glebas: "Glebas",
  "Documento-Proponentes-Participantes":
    "CPFs/CNPJs dos Proponentes/Participantes",
  Documento: "{num, plural, one {CPF/CNPJ} other {CPF/CNPJ}}",
  criterios: "Critérios",
  ajuda: "Ajuda",
  "ajuda-criterios-1":
    "De acordo com os dados inseridos, selecionamos critérios disponíveis para análise.",
  "ajuda-criterios-2":
    "Você deve selecionar pelo menos um dos critérios para análise. Ao lado de cada critério, você pode consultar o valor por hectare ou por documento.",
  "ajuda-criterios-3":
    "Abaixo da lista de critérios, você pode encontrar o valor total por hectare e por documento, bem como o valor total da consulta.",
  "nome-consulta": "Nome da Consulta",
  "nome-operacao": "Nome da Operação",
  "codigo-consulta": "Código da Consulta",
  "ajuda-nome-operacao": "Você pode inserir um nome para a sua operação.",
  "ajuda-area-nao-cultivada":
    "Você pode adicionar a área que não será utilizada para cultivo",
  "ajuda-nome-consulta":
    "Opcionalmente, você também pode inserir um nome para a sua consulta.",
  Executar: "Executar",
  Salvar: "Salvar",
  "salvar-descricao": "Salvar descrição",
  "ajuda-executar-operacao-1":
    "Para rodar a operação e suas consultas, selecione",
  "ajuda-salvar-operacao-1": "Para salvar a operação, selecione",
  "ajuda-executar-analise-1":
    "Para executar uma única consulta, você pode selecionar ",
  "ajuda-executar-analise-2":
    "Caso queira gerar várias consultas e executá-las todas ao mesmo tempo, você também pode salvar esta consulta.",
  "erro-inesperado-upload":
    "Erro inesperado ao enviar o arquivo. Por favor, verifique o arquivo e tente novamente.",
  "validacao-documentos": "Você precisa inserir pelo menos um CPF/CNPJ",
  "validacao-kml": "Você precisa inserir um arquivo KML",
  "confirmar-relatorio-delecao": "Confirmação de Deleção",
  "confirmar-delecao": "Certeza que deseja remover esta consulta?",
  "mensagem-input-operacao":
    "Insira os documentos e as informações da operação.",
  "mensagem-input-analise":
    "Insira os documentos e/ou envie o arquivo com a área a ser consultada. O valor de cada consulta é de {analysisBudget}.",
  "mensagem-input-analise-empresarial":
    "Insira os documentos e/ou envie o arquivo com a área a ser consultada.",
  "relatorios-empresariais": "Relatórios",
  "filtrar-por-usuario": "Filtrar por usuário",
  "selecione-um-ou-mais": "Selecione um ou mais",
  "selecione-um": "Selecione um",
  "solicitante-consulta": "Solicitante",
  "procure-por-nome": "Procure por nome",
  "mensagem-intro-video": "Veja como usar o BusCAR",
  "titulo-intro-video": "Como usar o BusCAR",
  "erro-documento-invalido":
    "Não conseguimos validar {num, plural, one {o seguinte documento} other {os seguintes documentos}}",
  "ajuda-analise-documento":
    "Você pode adicionar múltiplos CPFs e CNPJs. Caso já possua essa lista, pode copiar e colar vários documentos separados por vírgula ou ponto-e-vírgula",
  "e-ou": "e/ou",
  Enviando: "Enviando",
  "adicionar-arquivo": "Adicionar Arquivo",
  "aceitamos-formatos": "Aceitamos arquivos nos formatos:",
  "baixar-template": "Baixar Modelo",
  "formato-shapefile": "Shapefile, zipado ({link})",
  "formato-kml": "Kml ({link})",
  "formato-sicar":
    "{link}, zipado (O SICAR é o sistema de CAR - Cadastro Ambiental Rural - do Serviço Florestal Brasileiro)",
  "um-arquivo-por-consulta": "Você só pode enviar um arquivo por consulta.",
  continuar: "Continuar",
  "erro-verificar-saldo":
    "Erro ao verificar o saldo disponível. Por favor, tente novamente.",
  "saldo-insuficiente": "Saldo insuficiente para realizar a consulta.",
  "nao-encontrado": "Não Encontrado",
  "nao-encontrado-mensagem":
    "Não conseguimos localizar a página que você está procurando.",
  "tente-voltar": "Tente voltar à ",
  "pagina-login": "página de login",
  "remover-arquivo": "Remover Arquivo",
  "resultado-consulta": "Resultado da Consulta",
  "resultado-operacao": "Resultado da Operação",
  "cars-detectados": "CARs detectados",
  "nenhum-car-encontrado": "Nenhum CAR encontrado",
  "data-base": "Data Base",
  "data-consulta": "Data da Consulta",
  "data-operacao": "Data da Operação",
  "data-modificacao": "Data de Modificação",
  "ultima-atualizacao": "Última Atualização",
  "ordernar": "Ordenar",
  valor: "Valor",
  "mudancas-termos":
    "Os nossos Termos e a Política de Privacidade foram atualizados.",
  "mudancas-termos-descricao":
    "Os termos estão sendo atualizados para melhor se adequar à nova LGPD (Lei Geral de Proteção de Dados). Para continuar o uso do nosso sistema, será necessário o seu consentimento com os novos termos e políticas.",
  "nenhuma-infracao": "Nenhuma sobreposição encontrada",
  "infracoes-encontradas": "Sobreposições encontradas",
  "porcentagem-sobreposicao": "Porcentagem de sobreposição",
  "bioma": "Bioma",
  "nenhuma-infracao-documento": "Nenhuma ocorrência encontrada",
  "x-ocorrencias-encontradas": "{num} ocorrência(s) encontrada(s)",
  "cpfs-com-dap": "CPFs que apresentam DAP",
  "sem-titulo": "Sem título",
  "sem-contrato": "Sem contrato",
  "sem-referencia-bacen": "Sem referência BACEN",
  "sem-documento": "Sem documentos",
  "area-intersecao": "Área de Interseção",
  "area-gleba-fora-do-perimetro-do-car": "Área(s) de gleba(s) fora do perímetro do CAR",
  "documentos-com-problemas": "CPFs",
  "documentos-sem-problemas": "CPFs sem ocorrências",
  descricao: "Descrição",
  "ajuda-descricao": "Opcionalmente, você também pode inserir uma descrição.",
  "ajuda-data-cadastro": "Você pode inserir a data do cadastro",
  "cadastro-car": "Cadastro de CAR",
  fonte: "Fonte",
  "mensagem-processando-consulta":
    "Sua consulta ainda está sendo processada. Alguns critérios podem demorar algumas horas para serem processados.",
  "tipos-criterio": "Tipos de Critérios",
  "pagina-anterior": "Página Anterior",
  "proxima-pagina": "Próxima Página",
  "nenhuma-consulta-encontrada": "Nenhuma consulta encontrada",
  "nenhuma-operacao-encontrada": "Nenhuma operação encontrada",
  historico: "Histórico",
  operacao: "Operações",
  "nova-consulta": "Nova Consulta",
  "nova-operacao": "Nova Operação",
  "area-nao-cultivada": "Área não cultivada",
  sobre: "Sobre",
  "termos-uso": "Termos de Uso",
  "politica-privacidade": "Política de Privacidade",
  contato: "Contato",
  sair: "Sair",
  "possui-criterio-documento": "possui critério de documento",
  "possui-criterio-area": "possui critério de área",
  "li-e-aceito": "Declaro que li e aceito os",
  "e-a": "e a",
  "validar-conta": "Validar Conta",
  "sucesso-validacao-email": "Conta validada com sucesso",
  "erro-validacao-email": "Houve um problema ao validar sua conta",
  sucesso: "Successo",
  erro: "Erro",
  "sera-cobrado": "Você será cobrado",
  "confirmacao-relatorio": "Confirmação de Relatório",
  processada: "Processada",
  "nao-processada": "Não processada",
  sim: "Sim",
  nao: "Não",
  cancelar: "Cancelar",
  "executar-analise": "Executar Análise",
  "executar-selecionadas": "Executar Selecionadas",
  "executadas-sucesso":
    "{num} {num, plural, one {consulta executada} other {consultas executadas}} com sucesso",
  "executadas-erro":
    "Erro ao executar {num, plural, one {uma consulta com o seguinte erro} other {{num} consultas com os seguintes erros}}:",
  "exportar-como-pdf": "Exportar como PDF",
  "exportar-kml": "Exportar KML",
  "validacao-operacao": "Validação da Área Financiada",
  "validacao-compliance": "Validação de Compliance Socioambiental",
  "consultas-operacao": "Consultas da operação",
  contrato: "Número da Proposta/Contrato",
  "referencia-bacen": "Referência BACEN",
  "ajuda-referencia-bacen":
    "Você pode inserir um número de Referência do BACEN",
  "ajuda-contrato": "Você pode inserir um número de contrato.",
  "validacao-referencia-bacen":
    "Você precisa inserir um número de referência BACEN",
  "validacao-contrato": "Você precisa inserir um número de contrato",
  "validacao-nome": "Você precisa inserir um nome para a operação",
  "ocorreram-erros": "Ocorreram alguns erros",
  "resolver-captcha": "Resolva o captcha",
  endereco: "Endereço",
  fone: "Fone",
  "mensagem-home-office-telefone": "Estamos em home office, ligue-nos no",
  "horario-atendimento": "Horário de atendimento",
  "horario-atendimento-descricao":
    "de {de} a {ate}, horário de Belém-PA (UTC-3)",
  "mensagem-sobre-1":
    "O Terras Crédito Rural é um sistema que permite a apresentação e análise socioambiental de propostas de crédito rural para Instituições Financeiras",
  "mensagem-sobre-2":
    "O sistema cruza diferentes bancos de dados oficiais e produz um relatório de conformidade de acordo com a legislação do crédito rural brasilieiro.",
  "mensagem-sobre-3":
    "Isso é feito de forma transparente, ágil e simplificada, gerando maior segurança no processo de análise e aprovação do crédito rural para todos os envolvidos.",
  "perguntas-frequentes": "Perguntas Frequentes",
  fechar: "Fechar",
  "ir-para-contato": "Ir para a página de contato.",
  todos: "Todos",
  personalizado: "Personalizado",
  "bases-disponiveis": "Bases Disponíveis",
  "usuarios-unicos": "Usuários únicos",
  "usuarios-consultas": "Usuários com consultas",
  consultas: "Consultas totais",
  "consultas-normais": "Consultas normais",
  "consultas-empresariais": "Consultas empresariais",
  "contas-antes-lancamento": "Contas antes do lançamento",
  "contas-pos-lancamento": "Contas pós lançamento",
  "filtrar-por-data": "Filtrar por data",
  ate: "até",
  "todos-usuarios": "Todos usuários",
  "vincular-usuario-pj": "Vincule o usuário à uma PJ",
  "vincular-operacao": "Vincular à operação",
  vincular: "Vincular",
  "cadastre-car-para-ver": "Cadastre um CAR para visualizá-lo no mapa",
  "selecione-car-para-ver": "Selecione um CAR para visualizá-lo",
  "cadastre-selecione-gleba-para-ver":
  "Cadastre/Selecione uma gleba para visualizá-la no mapa",
  vinculado: "Vinculado",
  grafico: "Gráfico",
  usuarios: "Usuários",
  "entrou-em": "Entrou em",
  "numero-car": "Número CAR",
  "area-car": "Área do CAR",
  "tipo-imovel": "Tipo do Imóvel",
  status: "Status",
  "situacao-cadastro": "Situação cadastro",
  "condicao-cadastro": "Condição de cadastro",
  "data-registro-sicar": "Data de registro no SICAR",
  "data-analise-sicar": "Data da análise do CAR",
  "data-ultima-retificacao": "Data da última retificação",
  "numero-total-consultas": "Nº total de consultas",
  "primeira-consulta": "Primeira consulta",
  "ultima-consulta": "Última consulta",
  "sem-consulta": "Sem consulta",
  "consultas-feitas": "Consultas feitas",
  "consultas-restantes": "Consultas restantes",
  "total-usuarios": "Total de usuários vinculados",
  informacoes: "Informações",
  "conta-pj-master": "Conta PJ master",
  "conta-pj-direta": "Conta PJ direta",
  "plano-atual": "Plano atual",
  "dia-bilhetagem": "Dia de bilhetagem",
  "historico-consultas": "Histórico de consultas",
  "consultas-mensais": "consultas mensais",
  tolerancia: "tolerância",
  "admin": "Admin",
  "gestor": "Gestor",
  "operacional": "Operacional",
  "confirmacao-reenvio": "Confirmação de Reenvio",
  "reenvio-email-usuario": "Reenviar confirmação de e-mail do usuário {email}",
  "exportar-coordenadas": "Coordenadas em CSV",
  dias: "dias",
  horas: "horas",
  minutos: "minutos",
  segundos: "segundos",
  alertas: "Alertas",
  "modulos-fiscais": "Módulos fiscais",
  pronaf: "Pronaf",
  "ajuda-pronaf": "Identifique se operação é do tipo Pronaf",
  identificador: "Código Identificador",
  "sem-identificador": "Sem código identificador",
  "cpf-cnpj": "CPF / CNPJ",
  "operacao-car-descricao":
    "Insira abaixo todos os CAR que serão utilizados na operação",
  "formato-car-recibo": "Utilize o formato: PA-XXXXXXX-XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX",
  "formato-car-recibo2": "ou PA-XXXXXXX-XXXX.XXXX.XXXX.XXXX.XXXX.XXXX.XXXX.XXXX",
  "opcao-1": "Opção 1: Vinculação do CAR por recibo",
  "opcao-2": "Opção 2: Vinculação do CAR por .zip",
  "upload-zip": "Pressione o botão abaixo para fazer upload do CAR em .zip",
  "cadastrar-car": "Cadastrar CAR",
  "recibo-car": "Insira abaixo o código do CAR que você deseja inserir.",
  "lista-cars-cadastrados": "Lista de CARs cadastrados",
  "lista-glebas-cadastradas": "Lista de glebas cadastradas",
  "nenhum-car-cadastrado":
    "Você ainda não tem CARs cadastrados. Vincule um CAR para continuar",
  "nenhuma-gleba-cadastrada":
    "Você ainda não tem glebas cadastradas. Clique no botão Cadastrar glebas para continuar",
  carregando: "Carregando",
  gleba: "Gleba",
  "cancelar-desenho": "Cancelar desenho",
  "adicionar-gleba": "Adicionar gleba",
  "cadastrar-gleba": "Cadastrar glebas",
  "operacao-gleba-car-descricao":
    "Selecione um CAR e clique no botão para adicionar uma gleba. Você pode desenhar a gleba usando a ferramenta que está no mapa, ou importar um .zip ou .kml",
  "operacao-gleba-descricao":
    "Insira abaixo todas as glebas que serão analisadas na operação",
  "aviso-adicionando-desenho":
    "Aviso: você está adicionando uma gleba, desenhe no mapa acima.",
  "como-deseja-add-gleba": "Como você deseja adicionar a gleba?",
  "desenhar-mapa": "Desenhar no mapa",
  "fazer-upload-arquivo": "Fazer upload de um arquivo",
  "fazer-upload-glebas": "Fazer upload das glebas",
  "vinculacao-car": "Vinculação de CAR",
  "vinculacao-car-descricao":
    "Lista detectada de CAR sobrepostos às glebas inseridas na operação. Clique no CAR desejado e complete o captcha para vincular.",
  "car-vinculados": "CAR vinculados",
  "car-nao-vinculados": "CAR não vinculados",
  "car-vinculados-selecione-abaixo": "Selecione um CAR para ver detalhes",
  "car-nao-vinculados-selecione-abaixo":
    "Selecione um CAR abaixo para ver detalhes e vincular",
  "sem-car-vinculados":
    "Você ainda não tem CAR vinculados. Selecione um CAR na lista abaixo para vincular.",
  "sem-car-nao-vinculados":
    "Você não tem nenhum CAR que ainda não foi vinculado.",

  "detalhes-car-detectado": "Detalhes do CAR detectado",
  "vincular-car": "Vincular CAR",
  "clique-captcha-para-vincular-car":
    "Clique no botão abaixo e complete o captcha para vincular o CAR à operação",
  "gerando-captcha": "Gerando captcha",
  desvincular: "Desvincular",

  "glebas-identificadas-arquivo":
    "Foi identificado as seguintes áreas no arquivo. Selecione quais você deseja vincular à este CAR",
  "dados-da-operacao": "Dados da operação",
  resultados: "Resultados",
  "bem-vindo-plataforma": "Bem-vindo à plataforma",
  "tempo-restante-sessao": "Tempo restante de sessão",
  "guias-uso": "Guias de uso",
  "desenvolvido-por": "Desenvolvido por",
  "cadastrar-produto-sicor": "Cadastrar produto SICOR",
  "pesquise-caixa-abaixo":
    "Pesquise na caixa abaixo e selecione o produto desejado",
  "pesquise-codigo-nome": "Pesquise o código ou nome do produto desejado",
  codigo: "Código",
  finalidade: "Finalidade",
  atividade: "Atividade",
  modalidade: "Modalidade",
  variedade: "Variedade",
  cesta: "Cesta",
  zoneamento: "Zoneamento",
  consorcio: "Consórcio",
  "digite-produto-acima-resultados":
    "Digite o produto na caixa de pesquisa acima para aparecer os resultados",
  "detalhes-produto": "Detalhes do produto",
  "detalhes-gleba": "Detalhes da gleba",
  "data-inicio-plantio": "Data início plantio",
  "data-fim-plantio": "Data fim plantio",
  "data-inicio-colheita": "Data início colheita",
  "data-fim-colheita": "Data fim colheita",
  "remover-datas": "Remover datas",
  "adicionar-datas-opcional": "Adicionar datas (opcional)",
  "cadastrar-produto": "Cadastrar produto",
  "produtos-sicor-cadastrados": "Produtos SICOR cadastrados",
  "nenhum-produto-sicor-cadastrado":
    "Nenhum produto cadastrado, clique no boto abaixo para cadastrar",
  "etapa-anterior": "Etapa anterior",
  "etapa-proximo": "Próxima etapa",
  "descricao-resultados":
    "Nesta área você pode ver os resultados da análise da operação, assim como exportar essa operação.",
  geral: "Geral",
  "descricao-geral-resultados": "Resultados gerais da operação",
  "descricao-documento-resultados":
    "Resultados da análise de CPF/CNPJ vinculados à proposta, clique para ver.",
  "descricao-car-resultados":
    "Resultados da análise dos CARs vinculados à proposta, clique para ver.",
  "descricao-gleba-resultados":
    "Resultados da análise das glebas vinculadas à proposta, clique para ver.",
  "exportar-resultados": "Exportar Resultados",
  "exportar-json": "Exportar JSON",
  "erro-captcha-fora-ar": "Geração de captcha SICAR indisponível no momento",
  "erro-captcha-errado":
    "Erro ao vincular, verifique se a solução do captcha está correta",
  "saiba-se-car-utilizado": "Saiba se este CAR já foi utilizado em alguma operação no passado",
  "acoes": "Ações",
  "data": "Data",

  "criar-operacao": "Criar nova operação",
  "listar-operacoes": "Listar operações",
  "operacoes": "Operações",
  "central-acoes": "Central de ações",


  "imoveis": "Imóveis",
  "cadastrar-imovel": "Cadastrar Imóvel",
  "numero": "Número",
  "adicione-imoveis-descricao": "Adicione informações de imóveis que estejam presentes nesse CAR",
  "detalhes-car-cadastrado": "Detalhes do CAR cadastrado",
  "sem-imoveis-cadastrados": "Sem imóveis cadastrados",

  "nome-imovel": "Nome do imóvel",
  "parcela-sigef": "Parcela SIGEF",
  "sncr": "SNCR",
  "matricula": "Matrícula",
  "cns": "CNS",
  "nirf-cib": "NIRF/CIB",

  "input-nome-imovel-holder": "Digite um nome para identificar o imóvel",
  "input-parcela-sigef-holder": "Digite o número da parcela SIGEF",
  "input-sncr-holder": "Digite o número SNCR",
  "input-matricula-holder": "Digite o número da matrícula",
  "input-cns-holder": "Digite o número CNS",
  "input-nirf-cib-holder": "Digite o número NIRF/CIB",

  "trackid": "TrackID"
};
